import * as API from '../api';

export type AuthTokens = API.Components.Schemas.ApiTokenSet;

export class AuthError extends Error {
  constructor(message: string, public readonly errorKey: string) {
    super(message);
  }
}

export type AuthTokenStatus =
  | 'NotAuthenticated'
  | 'RefreshTokenExpired'
  | 'AccessTokenExpired'
  | 'Valid';
